module.exports = __webpack_public_path__ + "static/media/tn-mpants-thigh-tight.6175c2de.svg";